var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.167c-.5 0-.833.389-.833.833v.944c0 .5.389.834.833.834a.854.854 0 00.834-.834v-.889c0-.5-.39-.888-.834-.888z",
    fill: "#0066D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11.167c-.5 0-.833.389-.833.833v.944c0 .5.389.834.833.834a.854.854 0 00.834-.834v-.889c.055-.5-.334-.888-.834-.888z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.445 14c-.5 0-.834.389-.834.833v.945c0 .5.39.889.834.889a.854.854 0 00.833-.834v-.944c.056-.5-.333-.889-.833-.889zM9.445 8.333c-.445 0-.834.39-.834.89v3.055c0 .5.39.833.834.833.444 0 .833-.333.889-.833V9.222c0-.5-.39-.889-.89-.889z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.556 8.333c-.5 0-.833.39-.833.834v.944c0 .5.388.833.833.833a.854.854 0 00.833-.833v-.889c0-.5-.389-.889-.833-.889z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.611c-.5 0-.833.389-.833.889v.944c0 .5.389.834.833.834a.854.854 0 00.834-.834V6.5c0-.5-.334-.889-.834-.889zM12.5 16.722c-.5 0-.833.39-.833.834v.944c0 .5.389.833.833.833a.818.818 0 00.834-.833v-.944a.818.818 0 00-.834-.834z",
    fill: "#FAB908"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.556 11.889c-.5 0-.833.389-.833.833v3.056c0 .5.388.833.833.833a.854.854 0 00.833-.833v-3.056a.854.854 0 00-.833-.833z",
    fill: "#34A853"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 10c0-.5-.39-.833-.834-.833a.818.818 0 00-.833.833v5c0 .5.389.833.833.833a.818.818 0 00.834-.833v-5z",
    fill: "#FAB908"
  })));
};
export default SvgGoogle;